import Vue from 'vue';
import Component from 'vue-class-component';
import Ribbon from '@/core/ribbon/ribbon.vue';
// SPE begin
// import JhiFooter from '@/core/jhi-footer/jhi-footer.vue';
// import JhiNavbar from '@/core/jhi-navbar/jhi-navbar.vue';

import { EventBus } from '@gv/ammo-astra/dist';
import { EventBusType } from '@gv/ammo-astra/dist';
import { GoAppBarComponent as GoAppbar } from '@gv/ammo-grome';
// import { GoLeftDrawerComponent as GoLeftDrawer } from '@gv/ammo-grome';
import JhiNavbarExtended from '@/core/jhi-navbar-extended/jhi-navbar-extended.vue';

import { GoRightComponent as GoRight } from '@gv/ammo-grome';
import { GoRightDrawerComponent as GoRightDrawer } from '@gv/ammo-grome';
import { GoAlertStackComponent as GoAlertStack } from '@gv/ammo-grome';
import SpeBottomNavigation from '@/core/spe-bottom-navigation/spe-bottom-navigation.vue';

// import { GromeSample } from '@gv/ammo-grome';

// SPE end

import '@/shared/config/dayjs';
import { Authority } from '@/shared/security/authority';

@Component({
  components: {
    ribbon: Ribbon,
    // 'jhi-navbar': JhiNavbar, // SPE
    // 'jhi-footer': JhiFooter, // SPE

    // SPE begin
    'go-app-bar': GoAppbar,
    // 'go-left-drawer': GoLeftDrawer,
    'jhi-navbar-extended': JhiNavbarExtended,
    'go-right': GoRight,
    'go-right-drawer': GoRightDrawer,
    'go-alert-stack': GoAlertStack,
    'spe-bottom-navigation': SpeBottomNavigation,
    // SPE end
  },
})
export default class App extends Vue {
  // SPE Begin
  private drawer = false;
  private drawerRight = false;
  private right = false;
  private left = false;

  created() {
    this.register();
  }

  /**
   * Listen for 'notify' events
   * @private
   */
  private register(): void {
    const registry = EventBus.getInstance().register(EventBusType.ToggleDrawer, (drawer: string) => {
      if (drawer === 'drawerRight') {
        if (this.drawerRight) {
          this.drawerRight = !this.drawerRight;
        }
      }
    });
  }
  // SPE End
}
